import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageTableRowContent: {
    position: "relative",
    display: "flex",
    width: "100%",
    overflowX: "scroll",
    overflowY: "hidden",
    "&:hover::-webkit-scrollbar": {
      backgroundColor: "transparent"
    }
  }
}));
